(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.manageSchoolData = {
        name: 'schoolwork12.manageSchoolData',
        controllers: {
            manageSchoolData: 'schoolDataCtrl',
            schoolDataDetails: 'schoolDataDetails'
        },
        routes: {
            manageSchoolData: '/manage-school-data',
            schoolDataDetails: '/school-data-details'
        },
        templates : {
            manageSchoolData: 'schoolData/html/manageSchoolData.html',
            schoolDataDetails: 'schoolData/html/schoolDataDetails.html'
        },
        services: {
            schoolDataEditSvc: 'schoolDataEditSvc'
        },
        endpoints: {
            schoolDataEndPoint: schoolwork12.app.endpoint.concat('/schools/'),
            k12DataEndPoint: schoolwork12.app.endpoint.concat('/k12/'),
            
        },
        errorMessages: {
           invalidDate: "Classroom Start Date must be a valid date.",
           maxClassroomsSelectedForActivation: "Classroom Re-activation are limited to 1000 records. Please reset and restrict the number of selected classrooms to 1000 or less in order to continue.",
           abbrValid: "Abbreviation is required",
           percentValid: "Start % must be a number with no more than 5 decimal places",
           nameValid: "Name is required",
           gpaValid: "GPA must be a number with no more than 3 decimal places",
           abbrUniq: "Abbreviation must be unique for each Grademark",
           percentUniq: "Start % must be unique for each Grademark",
           nameUniq: "Name must be unique for each Grademark",
           startDateValid: "Invalid Start Date. Enter in MM/DD/YYYY format.",
           endDateValid: "Invalid End Date. Enter in MM/DD/YYYY format.",
           endDateRange: "End Date must be greater than or equal to the Start Date.",
           termNameValid: "Name is required.",
           termCountValid: "At least one School Term is required when saving the school year. Please add at least one term.",
           termFinalValid: "At least one School Term must be marked as Final when saving the school year. Please mark a term as Final.",
           termDuplicateNameValid: "Name must be unique for each School Term.",
           schoolPeriodInvalidSequenceValue: 'Invalid value for Sequence. Please enter a valid number.',
           schoolPeriodSequenceRequired: 'Sequence is required',
           schoolPeriodSequenceUnique: 'Sequence must be unique for each School Period',
           schoolPeriodNameRequired: 'Name is required',
           schoolPeriodNameUnique: 'Name must be unique for each School Period',
           noSchoolHolidays: 'No holidays exist for the selected year. Holidays may be set up for current and future years.',
           holidayStartDateRequired: 'Date is a required field. Please enter or select a Date in MM/DD/YYYY format.',
           holidayStartDateInvalid: 'Date must be in MM/DD/YYYY format.',
           holidayStartDateDuplicated: 'Date has been duplicated for another holiday.',
           holidayEndDateInvalid: 'End Date must be in MM/DD/YYYY format, if it is provided.',
           holidayEndDatePrior: 'End Date must be on or after the Start Date, if it is provided.',
           duplicateSchoolExitModalMessage: 'You have begun duplicating a school. Do you want to continue without saving your changes?',
           schoolDuplicateNameRequired: 'School Name is a required field. Please enter the name of the school that you want to create.',
           schoolDuplicateAbbrevRequired: 'School Abbreviation is a required field. Please enter the abbreviation of the school that you want to create.',
           schoolDuplicateNameUnique: 'School Name is already used by another school.  Please enter a unique School Name.',
           schoolDuplicateAbbrevUnique: 'School Abbreviation is already used by another school.  Please enter a unique School Abbreviation.',
           mainDataSchoolNameRequired: 'Name is a required field. Please enter a name for the school.',
           mainDataSchoolAbbrevRequired: 'Abbreviation is a required field. Please enter an abbreviation for the school.',
           mainDataSchoolZipInvalid: 'Invalid value for Zip. Please enter a number of exactly 5 digits.',
           mainDataSchoolCountryRequired: 'Country is required when providing an address. Please enter a country code for the school.',
           mainDataSchoolPhoneInvalid: 'Invalid value for Phone. Please enter a number of at least 10 digits.',
           mainDataSchoolDefaultBillRequired: 'Default Bill To is a required field. Please select a value from the list.',
           mainDataSchoolDefaultShipRequired: 'Default Ship To is a required field. Please select a value from the list.',
           mainDataSchoolEmailNotificationRequired: 'Email Notification is a required field. Please provide a value for this field (Yes, No).',
           mainDataSchoolAllowBoosterMatsRequired: 'Allow Booster Materials is a required field. Please provide a value for this field (Yes, No).',
           mainDataSchoolAllowRecycledMatsRequired: 'Allow Recycled Materials is a required field. Please provide a value for this field (Yes, No).',
           mainDataSchoolBillingRequired: 'Billing ID is a required field. Please enter a valid, numeric value that refers to an actual billing identifier.',
           mainDataSchoolBillingInvalid: 'An invalid billing identifier was entered. Please enter a valid, numeric value that refers to an actual billing identifier.',
           mainDataSchoolMaterialsRequired: 'Materials is a required field. Please select a value from the list.'
        }
	};
	
    angular.module(schoolwork12.app.manageSchoolData.name, ['ui.grid', 'ui.grid.resizeColumns', 'ui.grid.selection',
    	'ui.grid.pagination', 'ui.bootstrap','ngTagsInput']);

}(angular, schoolwork12));